import { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import MobileParentMapComponent from "./pages/Map/mobile-ParentMapComponent";
import DesktopParentMapComponent from "./pages/Map/desktop-ParentMapComponent";
import _ from "lodash";

export default function App() {

  //const [modalIsOpen, setModalIsOpen] = useState(false);
  const [mobile, setMobile] = useState<true | false>(false);
  const [modalIsOpen, setModalIsOpen] = useState<true | false>(false);
  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };


  // SET MOBILE MODE
  const mobileMode = () => {
    const screenWidth = window.screen.width;
    if (screenWidth < 1000) {
        setMobile(true);
    } else {
        setMobile(false);
    }
  };

  useEffect(() => {
      // Debounce the mobileMode function to reduce the frequency of its calls
      const debouncedMobileMode = _.debounce(mobileMode, 200);

      // Check on initial render
      mobileMode();

      // Setting up event listener for window resize
      window.addEventListener('resize', debouncedMobileMode);

      // Cleanup event listener on component unmount
      return () => {
          window.removeEventListener('resize', debouncedMobileMode);
      };
  }, []);
  

  return (
    <Router>
      <Routes>
        <Route path="/:userId">
          <Route path="recommendations" element={mobile === true ? <MobileParentMapComponent mobileMode={mobileMode} openModal={openModal} closeModal={closeModal} modalIsOpen={modalIsOpen} mapViewProps={'recs'}/> : <DesktopParentMapComponent mobileMode={mobileMode} openModal={openModal} closeModal={closeModal} modalIsOpen={modalIsOpen} mapViewProps={'recs'}/>} />
          <Route path="trips" element={mobile === true ? <MobileParentMapComponent mobileMode={mobileMode} openModal={openModal} closeModal={closeModal} modalIsOpen={modalIsOpen} mapViewProps={'trips'}/> : <DesktopParentMapComponent mobileMode={mobileMode} openModal={openModal} closeModal={closeModal} modalIsOpen={modalIsOpen} mapViewProps={'trips'}/>} />
        </Route>
      </Routes>
    </Router>
  );
}